
import CalendarIcon from './Icons/CalendarIcon.vue'
import CancelIcon from './Icons/CancelIcon.vue'
import CountdownTimer from './CountdownTimer.vue'
import LockIcon from './Icons/LockIcon.vue'
import ChevronLeftIcon from './Icons/ChevronLeftIcon.vue'
import ChevronRightIcon from './Icons/ChevronRightIcon.vue'
import LinkIcon from './Icons/LinkIcon.vue'

export default {
    components: {
        LinkIcon,
        CountdownTimer,
        CalendarIcon,
        CancelIcon,
        LockIcon,
        ChevronLeftIcon,
        ChevronRightIcon
    },
    props: {
        info: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            showFullDescription: false,
            borderColors: {
                red: 'rtl:border-r-red-500 ltr:border-l-red-500',
                yellow: 'rtl:border-r-yellow-500 ltr:border-l-yellow-500',
                blue: 'rtl:border-r-blue-500 ltr:border-l-blue-500',
                green: 'rtl:border-r-green-500 ltr:border-l-green-500',
                purple: 'rtl:border-r-purple-500 ltr:border-l-purple-500',
                gray: 'rtl:border-r-gray-500 ltr:border-l-gray-500'
            }
        }
    },
    computed: {
        borderClass () {
            return this.borderColors[this.info.color] ?? this.borderColors.gray
        },
        borderDirectionClass () {
            return 'rtl:border-r-4 ltr:border-l-4'
        },
        backgroundColorClass () {
            return this.info.color ? `bg-${this.info.color}-500` : 'bg-gray-500'
        },
        textColorClass () {
            return this.info.color ? `text-${this.info.color}-600` : 'text-gray-600'
        },
        isUnavailable () {
            return this.info.link === null || this.info.counter === null
        },
        truncatedDescription () {
            if (!this.info.description) { return '' }
            return this.info.description.length > 150
                ? this.info.description.substring(0, 150) + '...'
                : this.info.description
        }
    }
}
